/**
 * AcceptanceStatus - a run's PR review status, or the human verdict on its
 * no-PR decision when it opened no PR
 */

import { NoPrReviewStatusLabels, PRReviewStatuses } from '@resolve-ai/shared';
import type { NoPrReviewStatus, PRReviewStatus } from '@resolve-ai/shared';
import { StatusBadge } from '../common';

interface AcceptanceStatusProps {
  prReviewStatus: PRReviewStatus | null;
  noPrReviewStatus: NoPrReviewStatus | null;
}

export function AcceptanceStatus({ prReviewStatus, noPrReviewStatus }: AcceptanceStatusProps) {
  if (!prReviewStatus) {
    return <span className="text-gray-400">--</span>;
  }

  const isNoPrRun = Boolean(noPrReviewStatus);
  const isAwaitingNoPrReview = isNoPrRun && prReviewStatus === PRReviewStatuses.OPEN;
  const label = isAwaitingNoPrReview ? NoPrReviewStatusLabels.pending : undefined;

  return (
    <div className="flex items-center gap-2">
      <StatusBadge showDot={false} status={prReviewStatus} label={label} size="lg" />
      {isNoPrRun && (
        <span
          className="text-xs text-gray-500 dark:text-gray-400"
          title="Finished without opening a pull request"
        >
          No PR
        </span>
      )}
    </div>
  );
}
